<div class="whole-bg-overflow-hidden" *ngIf="!showTYpage">
    <!-- Header -->
    <div class="row unlock-header">
        <a href="https://www.worknigeria.com"><img src="../assets/images/logo.webp" /></a>
    </div>
    <!-- Unlock Workforce -->
    <div class="unlock-wf row">
        <div class="col-lg-1 col-0"></div>
        <div class="col-12 col-lg-5">
            <h1>Unlock a Better Workforce with the <span>Right Skills</span></h1>
            <p class="para-1">Finding the right talent is just the start. Your team needs more than technical skills.
                They need the ability to communicate, collaborate, and perform at their best.</p>
            <p class="para-2">That's why, when you recruit with us, we provide <span>free soft skills training</span>
                for your new hires to ensure seamless integration and better results.</p>
            <button (click)="scrollToForm()">Claim Offer</button>
        </div>
        <div class="col-12 col-lg-5 img-div">
            <img src="../../../assets/images/business_team_posing.webp" />
        </div>
        <div class="col-lg-1 col-0"></div>
    </div>
    <!-- Build Stronger Team -->
    <div class="strong-team">
        <h2>Build a Stronger Team with Our Recruitment Services</h2>
        <p>Our recruitment process is fast and effective, ensuring you have the talent needed to succeed.</p>
        <div class="card-container">
            <div class="card" *ngFor="let rp of recruit_process">
                <img [src]="rp.photo" />
                <h3>{{ rp.title }}</h3>
                <p>{{ rp.para }}</p>
            </div>
        </div>
        <div class="text-center">
            <button class="orange-button" (click)="scrollToForm()">Learn More</button>
        </div>
    </div>
    <!-- Simplify Workforce Management -->
    <div class="simplify-wf">
        <h2>Simplify Your Workforce Management</h2>
        <p>Let us handle your recruitment and outsourcing, so you can focus on growing your business.</p>
        <div class="card-container">
            <div class="card" *ngFor="let wf of simplify_wf">
                <img [src]="wf.photo" />
                <h3>{{ wf.title }}</h3>
                <p>{{ wf.para }}</p>
            </div>
        </div>
        <div class="text-center">
            <button class="orange-button" (click)="scrollToForm()">Learn More</button>
        </div>
    </div>
    <!-- Why Choose WorkNigeria -->
    <div class="choose-wn">
        <h2>Why Choose WorkNigeria?</h2>
        <div class="row">
            <div class="col-lg-2 col-0"></div>
            <div class="col-lg-4">
                <img src="../../../assets/images/choose-wn-img.webp" />
            </div>
            <div class="col-lg-5">
                <ul class="custom-list">
                    <li *ngFor="let item of recruit">
                        <h4>{{ item.title }}</h4>
                        <p>{{ item.para }}</p>
                    </li>
                </ul>
            </div>
            <div class="col-lg-1 col-0"></div>
        </div>
    </div>
    <!-- What clients say -->
    <div class="clients-say">
        <h2>What Our Clients Say</h2>
        <div class="card-container">
            <div class="card" *ngFor="let card of client_say">
                <p>{{ card.quote }}</p>
                <div class="card-names">
                    <h4 class="initial">{{ extractFirstLetter(card.naam) }}</h4>
                    <div>
                        <h5>{{ card.naam }}</h5>
                        <p class="p-comp">{{ card.company }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Ready to Empower the Workforce -->
    <div class="empower-wf" id="userDetailsFormDiv">
        <h2>Ready to Empower Your Workforce?</h2>
        <p class="para-3">At WorkNigeria, we don't just help you hire—we help you build a successful team. Enjoy
            free soft skills training for your recruits to ensure they succeed.</p>
        <h5>Let's Get Started Today!</h5>
        <p class="para-4">Fill out the form below, and we'll reach out to help you streamline your hiring and workforce
            management.</p>
        <form [formGroup]="userDetailsForm" class="empower-form" id="simpleForm">
            <!-- Input Field For Full Name -->
            <label class="input-label"><img src="../../../assets/images/person-icon.webp" /> Name</label>
            <div class="input-container">
                <input type="text" placeholder="Your name" class="form-control" formControlName="fullName">
            </div>
            <div *ngIf="f['fullName'].touched && f['fullName'].invalid" class="invaild-div">
                <span class="text-left text-danger pb-1" *ngIf="f['fullName'].errors?.['required']">
                    Name is required
                </span>
                <span class="text-left text-danger pb-1" *ngIf="f['fullName'].errors?.['pattern']">
                    Please enter a valid name.
                </span>
            </div>
            <!-- Input Field For Email -->
            <label class="input-label"><img src="../../../assets/images/email-icon-2.webp" /> Email</label>
            <div class="input-container">
                <input type="email" placeholder="example@company.com" class="form-control" formControlName="email">
            </div>
            <div *ngIf="f['email'].touched && f['email'].invalid" class="invaild-div">
                <span class="text-left text-danger pb-1" *ngIf="f['email'].errors?.['required']">Email is required.
                </span>
                <span class="text-left text-danger pb-1" *ngIf="f['email'].errors?.['pattern']">
                    Please enter a valid email.
                </span>
            </div>
            <!-- Input Field For Phone Number -->
            <label class="input-label"><img src="../../../assets/images/phone-icon.webp" /> Phone Number</label>
            <div class="input-container">
                <input type="text" placeholder="xxxxxxxxxxx" class="form-control" formControlName="phoneNumber">
            </div>
            <div *ngIf="f['phoneNumber'].touched && f['phoneNumber'].invalid" class="invaild-div">
                <span class="text-left text-danger pb-1" *ngIf="f['phoneNumber'].errors?.['required']">Phone Number is
                    required.
                </span>
                <span class="text-left text-danger pb-1" *ngIf="f['phoneNumber'].errors?.['pattern']">
                    Please enter a valid Phone Number.
                </span>
            </div>
            <div class="consent-checkbox">
                <input type="checkbox" id="consent" formControlName="consent" />
                <label for="consent">By submitting this form, you agree to be contacted by WorkNigeria using the details
                    you've provided. We value your
                    privacy—view our <a href="/privacy-policy">Privacy Policy</a>.
                </label>
            </div>
            <button (click)="submitForm()">Submit</button>
        </form>
    </div>
    <!-- Footer -->
    <div class="footer">
        <div class="row">
            <div class="col-0 col-lg-1"></div>
            <div class="col-lg-4 col-12">
                <h4 class="para-wn">Work<span>Nigeria</span></h4>
                <p class="para-desc">Connecting the right talent with the right opportunities to build stronger teams
                    across Nigeria.</p>
            </div>
            <div class="col-lg-3 col-0"></div>
            <div class="col-lg-4 col-0">
            </div>
        </div>
        <hr class="line-hr" />
        <h6>© 2025 WorkNigeria. All rights reserved.</h6>
    </div>
</div>